import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === "string" ? e.response.data.detail : "Please check the form and try again.")
  : "Something went wrong. Please try again.";

export const label = (key) => (key || "")
  .replace(/^age_/, "Age ").replace(/_plus$/, "+").replace(/_/g, " ")
  .replace(/(\d+k?) (\d+k?)/, "$1–$2").replace(/^./, (c) => c.toUpperCase());

export const has = (user, ...perms) => perms.some((p) => user?.permissions?.includes(p));
